import { render, staticRenderFns } from "./GuestProfileCard.vue?vue&type=template&id=56e108bd&"
import script from "./GuestProfileCard.vue?vue&type=script&lang=ts&"
export * from "./GuestProfileCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports